import { NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export function AppLayout({ socket }) {
  const { user, signOut } = useAuth()

  return (
    <div className="app">
      <header className="header">
        <h1>Email Ingestion Manager</h1>
        <div className="header-user">
          <span className="header-user-email">{user?.email}</span>
          <button className="header-logout-btn" onClick={signOut}>
            Logout
          </button>
        </div>
      </header>

      <nav className="nav">
        <NavLink to="/" end className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
          Dashboard
        </NavLink>
        <NavLink to="/accounts" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
          Accounts
        </NavLink>
        <NavLink to="/jobs" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
          Jobs &amp; Activity
        </NavLink>
        <NavLink to="/contacts" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
          Contacts
        </NavLink>
      </nav>

      <main className="main">
        <Outlet context={{ socket }} />
      </main>
    </div>
  )
}
